module.exports = __webpack_public_path__ + "static/media/baseline.3d8356a0.svg";